import paymentTypeMenu from '@src/payment/payment-type/menu';

import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Zahlungen')
    .setChildren([
        paymentTypeMenu,
    ]);
